import { Component, ViewChild, ElementRef, AfterViewInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import { fromLonLat, toLonLat } from 'ol/proj';
import OSM from 'ol/source/OSM';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import Style from 'ol/style/Style';
import Icon from 'ol/style/Icon';
import Circle from 'ol/geom/Circle';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';


@Component({
  selector: 'app-custom-map',
  templateUrl: './custom-map.component.html',
  styleUrls: ['./custom-map.component.scss']
})
export class CustomMapComponent implements AfterViewInit, OnChanges {
  @ViewChild('mapContainer', { static: true }) mapElement!: ElementRef;
  @Input() center: [number, number] = [-3.7038, 40.4168];
  @Input() markerUrl: string = 'https://cdn-icons-png.flaticon.com/512/684/684908.png';
  @Input() userMarkerCenter: [number, number] | null = null;
  @Input() userMarkerUrl: string | null = null;
  @Output() markerChanged = new EventEmitter<{ lat: number; lng: number }>();
  @Input() radius: number = 105;
  @Input() disabled: boolean = false;
  @Input() popup: boolean = false;


  private map!: Map;
  private markerLayer = new VectorLayer({
    source: new VectorSource()
  });

  ngAfterViewInit(): void {
    const marker = new Feature({
      geometry: new Point(fromLonLat(this.center))
    });
    marker.setStyle(new Style({
      image: new Icon({
        src: this.markerUrl,
        scale: 1
      })
    }));
    this.markerLayer.getSource()?.addFeature(marker);
    this.markerLayer.getSource()?.addFeature(this.createCircleFeature(this.center, this.radius));

    this.map = new Map({
      target: this.mapElement.nativeElement,
      layers: [
        new TileLayer({ source: new OSM() }),
        this.markerLayer
      ],
      view: new View({
        center: fromLonLat(this.center),
        zoom: 18
      }),
      controls: []
    });

    this.map.on('click', (event) => {
      if (this.disabled) return;

      const [lon, lat] = toLonLat(event.coordinate);
      this.markerChanged.emit({ lat, lng: lon });

      this.markerLayer.getSource()?.clear();

      const newMarker = new Feature({
        geometry: new Point(fromLonLat([lon, lat]))
      });
      newMarker.setStyle(new Style({
        image: new Icon({
          src: this.markerUrl,
          scale: 1
        })
      }));
      this.markerLayer.getSource()?.addFeature(newMarker);
      this.markerLayer.getSource()?.addFeature(this.createCircleFeature(this.center, this.radius));
    });

    //Marcador de usuario
    if (this.userMarkerCenter && this.userMarkerUrl) {
      const userMarker = new Feature({
        geometry: new Point(fromLonLat(this.userMarkerCenter))
      });
      userMarker.setStyle(new Style({
        image: new Icon({
          src: this.userMarkerUrl,
          scale: 1.6
        })
      }));
      this.markerLayer.getSource()?.addFeature(userMarker);
    }


  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['center'] && this.map) {
      const [lng, lat] = this.center;

      // Centrar el mapa
      this.map.getView().setCenter(fromLonLat([lng, lat]));

      // Mover el marcador
      this.markerLayer.getSource()?.clear();
      const newMarker = new Feature({
        geometry: new Point(fromLonLat([lng, lat]))
      });
      newMarker.setStyle(new Style({
        image: new Icon({
          src: 'https://cdn-icons-png.flaticon.com/512/684/684908.png',
          scale: 0.05
        })
      }));
      this.markerLayer.getSource()?.addFeature(newMarker);
      this.markerLayer.getSource()?.addFeature(this.createCircleFeature(this.center, this.radius));


    }
  }

  private createCircleFeature(center: [number, number], radiusMeters: number): Feature {
    const circle = new Circle(fromLonLat(center), radiusMeters);
    const feature = new Feature(circle);

    feature.setStyle(new Style({
      stroke: new Stroke({ color: '#007ac3', width: 2 }),
      fill: new Fill({ color: 'rgba(0, 122, 195, 0.2)' })
    }));

    return feature;
  }


}
